import React from 'react';
import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import customMatch from '../Invoice/customMatch';


function renderInputComponent(inputProps) {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = customMatch(suggestion, query);
  const parts = parse(suggestion, matches);

  return (
    <MenuItem selected={isHighlighted} component="div">
      <div>
        {parts.map((part, i) => (
          <span key={i} style={{ fontWeight: part.highlight ? 600 : 400, color: part.highlight ? "blue" : "black" }}>
            {part.text}
          </span>
        ))}
      </div>
    </MenuItem>
  );
}



function getSuggestions(value, materialList) {
  const inputValue = deburr(value.trim()).toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  return inputLength === 0
    ? []
    : materialList.filter(suggestion => {
        const keep =
          count < 5 && suggestion.toLowerCase().includes(inputValue.toLocaleLowerCase());
          //count < 5 && suggestion.fieldData.Item.slice(0, inputLength).toLowerCase() === inputValue;
        if (keep) {
          count += 1;
        }

        return keep;
      });
}

function getSuggestionValue(suggestion) {
  return suggestion;
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  container: {
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'fixed',
    zIndex: 1,
    marginTop: theme.spacing(1),
    width: '90%',
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  divider: {
    height: theme.spacing(2),
  },
}));

export default function IntegrationAutosuggest(props) {
  const classes = useStyles();

  const [stateSuggestions, setSuggestions] = React.useState([]);

  const handleSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value, props.materials));
  };

  const handleSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const handleChange = name => (event, { newValue }) => {
    props.changeValue(newValue);
  };

  const autosuggestProps = {
    renderInputComponent,
    suggestions: stateSuggestions,
    onSuggestionsFetchRequested: handleSuggestionsFetchRequested,
    onSuggestionsClearRequested: handleSuggestionsClearRequested,
    getSuggestionValue,
    renderSuggestion,
    onSuggestionSelected: (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        props.changeChoice(suggestion);
    },
  };

  return (
    <div className={classes.root}>
      
      <Autosuggest
        {...autosuggestProps}
      
        inputProps={{
          classes,
          id: 'react-autosuggest-simple',
          label: props.label,
          placeholder: props.placeholder,
          value: props.value,
          onChange: handleChange('single'),
        }}
      
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion,
        }}
      
        renderSuggestionsContainer={options => (
          <Paper {...options.containerProps} square>
            {options.children}
          </Paper>
        )}
      
      />
    
    </div>
  
  );
}